import React from 'react';
import { useSetWidgetAttribute } from '../../hooks/useSetWidgetAttribute.js';
import { useSelector } from 'react-redux';
import { useReportOptions } from '../../hooks/useReportOptions.js';
import Select from '../../../common/Select.jsx';
import styles from '../base/CommonSettings.module.scss';
import CollapsibleSection from '../../../common/CollapsibleSection.jsx';
import WidgetTitleSettings from '../../settings_sidebar/WidgetTitleSettings.jsx';

function WorkflowStatusWidgetSettings({ widgetId }) {
    const setAttribute = useSetWidgetAttribute(widgetId);
    const all_submissions = useSelector(state => state.dashboard.widgets[widgetId].settings?.all_submissions);
    const own_projects = useSelector(state => state.dashboard.widgets[widgetId].settings?.own_projects);
    const assigned_workflows = useSelector(state => state.dashboard.widgets[widgetId].settings?.assigned_workflows);
    const show_days_passed = useSelector(state => state.dashboard.widgets[widgetId].settings?.show_days_passed);
    const workflow_id = useSelector(state => state.dashboard.widgets[widgetId].settings?.workflow_id);
    const {data: workflowOptions} = useReportOptions();

    return (<>
        <hr />
        <CollapsibleSection title={I18n.t('content_settings')}>
            <WidgetTitleSettings widgetId={widgetId} />
            <fieldset>
            <label>{I18n.t("projects_scope_conf")}</label>
            <div styles={styles['settings-section']}>
                <div styles={styles['settings-option']}>
                <input
                    type="checkbox" 
                    name="all_submissions" 
                    checked={all_submissions} 
                    onChange={e => setAttribute('settings.all_submissions', e.target.checked)} 
                />
                <label htmlFor="all_submissions" style={{marginLeft: '0.5rem'}}>{I18n.t('all_submissions')}</label>
                </div>
                <div styles={styles['settings-option']}>
                <input
                    type="checkbox" 
                    name="own_projects" 
                    checked={own_projects} 
                    onChange={e => setAttribute('settings.own_projects', e.target.checked)} 
                />
                <label htmlFor="own_projects" style={{marginLeft: '0.5rem'}}>{I18n.t('own_projects')}</label>
                </div>
                <div styles={styles['settings-option']}>
                <input
                    type="checkbox" 
                    name="assigned_workflows" 
                    checked={assigned_workflows} 
                    onChange={e => setAttribute('settings.assigned_workflows', e.target.checked)} 
                />
                <label htmlFor="assigned_workflows" style={{marginLeft: '0.5rem'}}>{I18n.t('assigned_workflows')}</label>
                </div>
            </div>
            </fieldset>
            <div styles={styles['settings-section']}>
                <div styles={styles['settings-option']}>
                <div>
                    <label>{I18n.t("widget_show_days_passed")}</label>
                    <label className="w-100">
                    <input type="radio" name="show_days_passed" defaultChecked={!show_days_passed || show_days_passed !== 'false'} defaultValue="true" onChange={(e) => setAttribute("settings.show_days_passed", "true")} style={{ display: 'inline', marginRight: '0.5rem' }}/>
                    {I18n.t("option_yes")}
                    </label>
                    <label>
                    <input type="radio" name="show_days_passed" defaultChecked={show_days_passed && show_days_passed === 'false'} defaultValue="false" onChange={(e) => setAttribute("settings.show_days_passed", "false")} style={{ display: 'inline', marginRight: '0.5rem' }}/>
                    {I18n.t("option_no")}
                    </label>
                </div>
                </div>
            </div>
            <fieldset>
                <label className="w-100">
                {I18n.t("monitoring_reports")}
                <Select
                    value={workflow_id}
                    options={(workflowOptions || []).map(v => ({value: v.id, label: v.name}))} 
                    isMulti = {false}
                    onChange={(v) => setAttribute("settings.workflow_id", v)}
                /> 
                </label>
            </fieldset>
        </CollapsibleSection>
    </>);
}

export default WorkflowStatusWidgetSettings;
